var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMapPininline = function SvgMapPininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: "#1C72E7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6c0 2.148 1.747 5.292 5.22 9.625a1 1 0 0 0 1.56 0C12.254 11.292 14 8.148 14 6A6 6 0 0 0 2 6Zm6-4a4 4 0 0 1 4 4c0 1.403-1.328 3.914-4 7.382C5.328 9.914 4 7.403 4 6a4 4 0 0 1 4-4Z",
    fill: "#1C72E7"
  })));
};

export default SvgMapPininline;